import styled from 'styled-components';
import { PinPukHelpIcon } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons/help';
import { ChevronIcon } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons';

const DeviceIconStyled = styled(PinPukHelpIcon)`
  width: 28px;
  height: 28px;
`;

const IconContainerStyled = styled.div`
  width: 28px;
  height: 28px;
  margin-top: -15px;
`;
const RoamingContainerStyled = styled.div`
  display: flex;
  padding: 24px 48px 32px 48px;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 5px 10px 0px rgba(14, 20, 29, 0.15);
`;

const RoamingHeaderStyled = styled.div`
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 5px 10px 0px rgba(14, 20, 29, 0.15);
  margin-bottom: 18px;

  p {
    color: #0e141d;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }

  svg {
    transform: scale(0.7);
  }
`;

const RoamingContentStyled = styled.div`
  text-align: center;
  h1 {
    color: #0e141d;
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    line-height: 26px;
  }
`;

const RoamingSelectorStyled = styled.div`
  display: flex;
  max-width: 384px;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  width: 100%;

  .MuiAutocomplete-root {
    width: 100%;
  }

  h2 {
    color: #0e141d;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
  }
`;

const FrequentCountriesContainerStyled = styled.div`
  display: block;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  align-self: stretch;

  h1 {
    color: #0e141d;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    padding-bottom: 20px;
  }
`;

const CountriesContainerStyled = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  grid-template-columns: 1fr;
  padding-bottom: 16px;
  @media (min-width: 769px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const FrequentCountrieStyled = styled.div`
  display: flex;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid #c9cfd7;
  background: #fff;
  img {
    width: 25px;
    height: 25px;
  }
`;

const ChevronStyled = styled(ChevronIcon)`
  transform: rotate(-90deg);
`;

const SeeMoreButtonStyled = styled.div`
  margin: auto;
  font-size: 14px;
  text-transform: none;
  color: #4d008c;
  display: flex;
  max-width: 278px;
  height: 50px;
  padding: 16px 40px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  cursor: pointer;
`;

export {
  RoamingContainerStyled,
  IconContainerStyled,
  DeviceIconStyled,
  RoamingContentStyled,
  RoamingHeaderStyled,
  RoamingSelectorStyled,
  FrequentCountriesContainerStyled,
  CountriesContainerStyled,
  FrequentCountrieStyled,
  ChevronStyled,
  SeeMoreButtonStyled,
};
